import type { DocCollection, DocMeta } from '@blocksuite/store';
import type { Atom } from 'jotai';
import { atom, useAtomValue } from 'jotai';

const weakMap = new WeakMap<DocCollection, Atom<DocMeta[]>>();

const shouldFilterDoc = (docMeta: DocMeta): boolean => {
  const tags = docMeta.tags || [];

  // Filter out temp:peek documents (email composition and pre-read docs)
  if (tags.includes('temp:peek')) {
    return true;
  }

  return false;
};

// this hook is extracted from './use-block-suite-page-meta.ts' to avoid circular dependency
export function useAllBlockSuiteDocMeta(
  docCollection: DocCollection
): DocMeta[] {
  if (!weakMap.has(docCollection)) {
    const baseAtom = atom<DocMeta[]>(
      [...docCollection.meta.docMetas].filter(docMeta => !shouldFilterDoc(docMeta))
    );
    weakMap.set(docCollection, baseAtom);
    baseAtom.onMount = set => {
      set([...docCollection.meta.docMetas].filter(docMeta => !shouldFilterDoc(docMeta)));
      const dispose = docCollection.meta.docMetaUpdated.on(() => {
        set([...docCollection.meta.docMetas].filter(docMeta => !shouldFilterDoc(docMeta)));
      });
      return () => {
        dispose.dispose();
      };
    };
  }
  return useAtomValue(weakMap.get(docCollection) as Atom<DocMeta[]>);
}
